import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Progress } from 'antd';
import {
  ItemCard,
  CardHeader,
  CardHeaderLeft,
  RankText,
  ItemInfo,
  ItemName,
  CategoryBadge,
  TrendIndicator,
  TrendText,
  MetricsRow,
  MetricItem,
  MetricLabel,
  MetricValue,
  MetricValueGreen,
  ProgressSection,
  ProgressHeader,
  ProgressLabel,
  ProgressValue,
  StyledProgress,
  FooterRow,
} from './styles';
import { PopularItemCardProps } from './types';
import { TREND_ICON_CONFIG, TREND_TYPES } from './constants';

const PopularItemCard: React.FC<PopularItemCardProps> = ({ item, index }) => {
  const trendConfig = TREND_ICON_CONFIG[item.trend] || TREND_ICON_CONFIG[TREND_TYPES.NEUTRAL];

  return (
    <ItemCard>
      <CardHeader>
        <CardHeaderLeft>
          <RankText>#{index + 1}</RankText>
          <ItemInfo>
            <ItemName>{item.item}</ItemName>
            <CategoryBadge>{item.categoryName}</CategoryBadge>
          </ItemInfo>
        </CardHeaderLeft>
        <TrendIndicator>
          <FontAwesomeIcon icon={trendConfig.icon} color={trendConfig.color} />
          <TrendText trend={item.trend}>
            {item.volumeGrowth > 0 ? '+' : ''}{item.volumeGrowth}%
          </TrendText>
        </TrendIndicator>
      </CardHeader>

      <MetricsRow>
        <MetricItem>
          <MetricLabel>Times Sold</MetricLabel>
          <MetricValue>{item.totalTimesSold.toLocaleString()}</MetricValue>
        </MetricItem>
        <MetricItem>
          <MetricLabel>Revenue</MetricLabel>
          <MetricValueGreen>${item.totalRevenue.toLocaleString()}</MetricValueGreen>
        </MetricItem>
      </MetricsRow>

      <ProgressSection>
        <ProgressHeader>
          <ProgressLabel>Popularity Score</ProgressLabel>
          <ProgressValue>{item.popularityScore}/100</ProgressValue>
        </ProgressHeader>
        <StyledProgress>
          <Progress
            percent={item.popularityScore}
            strokeColor={{
              '0%': '#4299E1',
              '100%': '#63B3ED',
            }}
            showInfo={false}
            size="small"
          />
        </StyledProgress>
      </ProgressSection>

      <FooterRow>
        <MetricItem>
          <MetricLabel>Revenue Growth</MetricLabel>
          <TrendText trend={item.trend}>
            {item.revenueGrowth > 0 ? '+' : ''}{item.revenueGrowth}%
          </TrendText>
        </MetricItem>
        <MetricItem>
          <MetricLabel>Previous Period</MetricLabel>
          <MetricLabel>{item.previousPeriod?.totalTimesSold || 0} sold</MetricLabel>
        </MetricItem>
      </FooterRow>
    </ItemCard>
  );
};

export default PopularItemCard;
